import RSVP from 'rsvp';

export default function (options) {
    return new RSVP.Promise((resolve, reject) => {
        const xhr = $.ajax(options);

        xhr.done((data) => {
            resolve(data);
        });

        xhr.fail((data) => {
            reject(data);
        });
    });
}
